export default "__VITE_ASSET__LX0BgBh$__"